import { useState } from "react";
import { bookAppointmentService } from "../api/apiServices";
import Lastmenu from "./Lastmenu";
import Mainmenu from "./MainMenu";

const BookAppointment = ({ doctorId , name: initialName, mobile: initialMobile }) => {
  const [name, setName] = useState(initialName || "");
  const [mobile, setMobile] = useState(initialMobile || "");
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [location, setLocation] = useState('');
  const [treatmentFor, setTreatmentfor] = useState('');
  const [showFrame2, setShowFrame2] = useState(false);

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const today = new Date().toISOString().split("T")[0];

  const handleSubmit2 = () => {
    setShowFrame2(true);
  };

  const handleSubmit = async () => {
    if (!name || !mobile || !date || !time || !location || !treatmentFor) {
      alert("Please fill out all fields.");
      return;
    }

    setLoading(true);

    try {
      const response = await bookAppointmentService({
        name,
        mobile,
        appointment_date: date,
        appointment_time: time,
        location,
        treatment_for: treatmentFor,
        doctor_id: doctorId || null,
      });

      console.log(response.data);
      setSubmitted(true);
    } catch (error) {
      alert("❌ Failed to book appointment.");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="frame1 animated-frame">
        {!submitted ? (
          <>
            <h2 style={{ textAlign: "center", color: "#fe5631", marginTop: "-5px" }}>
              Book an Appointment
            </h2>
            <div style={{ fontSize: '0.9rem', textAlign: 'center' }}>
              <input type="text" placeholder="Please Enter Your Name" value={name} className="input-text2" onChange={(e) => setName(e.target.value)} disabled={loading} />
              <input type="text" placeholder="Please Enter Your Mobile Number" value={mobile} className="input-text2" onChange={(e) => setMobile(e.target.value)} disabled={loading} />
              <input type="date" min={today} value={date} className="input-text2" onChange={(e) => setDate(e.target.value)} disabled={loading} />
              <input type="time" min="09:00" max="21:00" value={time} className="input-text2" onChange={(e) => setTime(e.target.value)} disabled={loading} />

              <select className="input-text2" style={{ maxWidth: '22rem' }} value={location} onChange={(e) => setLocation(e.target.value)} disabled={loading}>
                <option value="">- select Location -</option>
                <option value="Madhapur">Madhapur</option>
                <option value="Miyapur">Miyapur</option>
                <option value="Attapur">Attapur</option>
                <option value="Suchitra">Suchitra</option>
                <option value="Malakpet">Malakpet</option>
              </select>

              <select className="input-text2" style={{ maxWidth: '22rem' }} value={treatmentFor} onChange={(e) => setTreatmentfor(e.target.value)} disabled={loading}>
                <option value="">- select treatment -</option>
                <option value="Infertility">Infertility</option>
                <option value="Gynecology">Gynecology</option>
                <option value="Laparoscopy">Laparoscopy</option>
                <option value="Others">Others</option>
              </select>

              <div style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem', marginTop: '1rem' }}>
                <button className="detatils-button2" onClick={handleSubmit} disabled={loading}>
                  {loading ? "Booking..." : "Book Appointment"}
                </button>
                <button className="detatils-button2" onClick={handleSubmit2} disabled={loading}>
                  Previous Menu
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <h3 style={{ color: "green", textAlign: "center" }}>✅ Your appointment has been booked!</h3>
            <p style={{ textAlign: "center" }}>Our team will contact you shortly.</p>
          </>
        )}
      </div>

      {submitted && <Lastmenu />}
      {showFrame2 && <Mainmenu />}
    </>
  );
};

export default BookAppointment;
